import { buildCsvFromRows } from '../../shared/csv-core/infra/buildCsv';
import type { ExpenseSettlementListRow } from '../domain/expenseTypes';
import {
  expenseSettlementMethodLabel,
  expenseSettlementStatusLabel,
} from '../domain/expenseLabels';

export function buildExpenseSettlementsCsv(rows: ExpenseSettlementListRow[]): string {
  const headers = [
    'Fecha pago',
    'Método',
    'Monto pago',
    'Estado pago',
    'Proveedor factura',
    'Ref. comprobante',
    'Descripción',
    'Fecha factura',
    'Total factura',
    'Categoría',
    'Nota',
    'ID pago',
    'ID factura',
  ];
  const data = rows.map((row) => [
    row.paidAt.slice(0, 10),
    expenseSettlementMethodLabel(row.method),
    String(row.settlementAmount),
    expenseSettlementStatusLabel(row.settlementStatus),
    row.supplierName ?? '',
    row.receiptRef ?? '',
    row.expenseDescription ?? '',
    row.expenseDate,
    String(row.expenseAmount),
    row.categoryName || row.categorySlug,
    row.note ?? '',
    row.settlementId,
    row.expenseId,
  ]);
  return buildCsvFromRows(headers, data);
}
